import React, { Component } from 'react';
import { DateRange } from 'react-date-range';

//import {es} from 'date-fns/locale';
import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

class PeriodGeneralStatus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            range: {},
            dateRange: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                },
            },
        }
    }
    /*onOpenModal = () => {
        this.setState({
            open: true,
            range: {}
        });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    onCloseModalButton = () => {
        this.setState({ open: false });
        Graph(this.props, this.state, 'custom')
    };

    handleRangeChange(which, payload) {
        this.setState({
            [which]: {
                ...this.state[which],
                ...payload,
            },
        });
    }*/
    
    render() {
        const { open } = this.state;
        return (
            <div>
                <List>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, 'hora')} className="button muted-button">Última hora</Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, '3hora')} className="button muted-button">Últimas 3 horas</Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, '6hora')} className="button muted-button">Últimas 6 horas</Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, '12hora')} className="button muted-button">Últimas 12 horas</Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, 'dia')} className="button muted-button">Último día</Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, '2dia')} className="button muted-button">Últimos 2 días</Button>
                    </ListItem>
                    <ListItem>
                    <Button onClick={() => Graph(this.props, this.state, 'semana')} className="button muted-button">Última Semana</Button>
                    </ListItem>
                    <ListItem>
                    <Button onClick={() => Graph(this.props, this.state, '2semana')} className="button muted-button">Últimas 2 Semanas</Button>
                    </ListItem>
                    <ListItem>
                    <Button onClick={() => Graph(this.props, this.state, 'mes')} className="button muted-button">Último mes</Button>
                    </ListItem>
                    {/*<ListItem>
                            <Button onClick={this.onOpenModal}>Custom</Button>
                            <Popover open={open} 
                                    onClose={this.onCloseModal} 
                                    anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                                    transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                                <div>
                                    <DateRange
                                        maxDate={addDays(new Date(), 0)}
                                        minDate={addMonths(new Date(), -3)}
                                        locale={es}
                                        onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                        moveRangeOnFirstSelection={false}
                                        ranges={[this.state.dateRange.selection]}
                                        className={'PreviewArea'}
                                    />
                                </div>
                                <Button onClick={this.onCloseModalButton}>Generar</Button>
                            </Popover>
                    </ListItem>*/}
                </List>
            </div>
        )
    }
}

function Graph(props, state, id) {
    props.onClick(props.period, props.typeGraph, state.dateRange.selection, id)
}


export default PeriodGeneralStatus;